import React from "react"
import TableCell from "@mui/material/TableCell"
import TableRow from "@mui/material/TableRow"
import dayjs from "dayjs"
import { useSearchParams } from "react-router-dom"
import { useGetAvailableScheduleQuery } from "../../../api/ScheduleApi"
import { keycloakInstance } from "../../../../../shared/libs/keycloack/config"

import Stack from "@mui/material/Stack"

import RecentActorsIcon from "@mui/icons-material/RecentActors"
import { IconButton, Typography } from "@mui/material"
import { useDispatch } from "react-redux/es/hooks/useDispatch"
import { setAvailableScheduleCandidates } from "../../create/dialogs/model/AvalaibleScheduleCandidates"
import { IСreateAvailableSchedule } from "../../../model/create/СreateAvailableSchedule"

const AvailableScheduleRow = ({ setEditRow, setOpen, open }: any) => {
  const [searchParams] = useSearchParams()

  const dispatch = useDispatch()

  const status = searchParams.get("status") || "active"
  const department = searchParams.get("department")
  const project = searchParams.get("project")
  const line = searchParams.get("line")

  let query = ``

  if (status) {
    query += `&status=${status}`
  }

  if (department) {
    query += `&department=${department}`
  }
  if (project) {
    query += `&project=${project}`
  }
  if (line) {
    query += `&line=${line}`
  }

  const availableSchedule = useGetAvailableScheduleQuery(query)

  const openModal = (row: IСreateAvailableSchedule) => {
    setEditRow(row)

    keycloakInstance.realmAccess?.roles.some((role) =>
      ["hiring-admin"].includes(role),
    ) &&
      setOpen({
        ...open,
        openCreateAvailableSchedule: { open: true, type: "edit" },
      })
  }

  console.log(
    keycloakInstance.realmAccess?.roles,
    "keycloakInstance.realmAccess?.roles",
  )
  const isNotRecruiter = () => {
    return keycloakInstance.realmAccess?.roles.some((role) =>
      [
        "hiring-admin",
        "hiring-interviewer",
        "hiring-viewer",
        "hiring-training",
      ].includes(role),
    )
  }

  if (availableSchedule.error) {
    return <TableRow>{JSON.stringify(availableSchedule.error)}</TableRow>
  }

  if (availableSchedule.isLoading) {
    return (
      <TableRow>
        <></>
      </TableRow>
    )
  }

  return (
    <>
      {availableSchedule.data.map((row: any) => {
        return (
          <TableRow
            hover
            key={row.id}
            sx={{
              cursor: keycloakInstance.realmAccess?.roles.some((role) =>
                ["hiring-admin"].includes(role),
              )
                ? "pointer"
                : "default",
              borderBottom: (theme) =>
                theme.palette.mode === "light"
                  ? "10px solid rgba(255, 255, 255, 1)"
                  : "10px solid #272626",
              borderTop: (theme) =>
                theme.palette.mode === "light"
                  ? "10px solid rgba(255, 255, 255, 1)"
                  : "10px solid #272626",
              borderRadius: "4px",
              height: "54px",
              "&:hover": {
                backgroundColor: "red",
              },
              "&:hover .iconButton": {
                opacity: 1,
              },
            }}
          >
            <TableCell
              onClick={() => openModal(row)}
              sx={{
                bgcolor:
                  row.requirement.status === "active"
                    ? "rgba(202, 227, 200, 1)"
                    : row.requirement.status === "expired"
                    ? "rgba(255, 218, 198, 1)"
                    : "rgba(213, 221, 228, 1)",
                borderRadius: "4px",
                boxSizing: "border-box",
                minWidth: "68px",
                whiteSpace: "normal",
                wordWrap: "break-word",
                lineHeight: "1.2",
              }}
            >
              {row.requirement.status === "active" ? (
                <>
                  Активен <br />
                  до {dayjs.utc(row.requirement.endDate).format("DD.MM")}
                </>
              ) : row.requirement.status === "expired" ? (
                <>
                  Активен
                  <br /> до {dayjs.utc(row.requirement.endDate).format("DD.MM")}
                </>
              ) : (
                <>
                  Завершено
                  <br /> {dayjs.utc(row.requirement.endDate).format("DD.MM")}
                </>
              )}
            </TableCell>

            <TableCell
              onClick={() => openModal(row)}
              sx={{ whiteSpace: "nowrap" }}
            >
              {row.id}
            </TableCell>
            <TableCell
              onClick={() => openModal(row)}
              sx={{ whiteSpace: "nowrap" }}
            >
              {row.graphType.name}
            </TableCell>
            <TableCell
              onClick={() => openModal(row)}
              sx={{ whiteSpace: "nowrap" }}
            >
              <Stack direction={"column"} justifyContent={"space-around"}>
                <Typography
                  sx={{ fontSize: 14, fontWeight: "bold", lineHeight: "1.2" }}
                >
                  {`${row.schedule?.pattern.name}  ${dayjs
                    .utc(row.schedule?.startDate)
                    .format("HH:mm")} - ${dayjs
                    .utc(row.schedule?.endDate)
                    .format("HH:mm")}`}
                </Typography>
                <Typography sx={{ fontSize: 14, lineHeight: "1.2" }}>
                  {row.workDays &&
                    `${dayjs(row.workDays?.startDate).utc().format("DD.MM")} -
            ${dayjs(row.workDays?.endDate).utc().format("DD.MM")} `}
                </Typography>
              </Stack>
            </TableCell>

            <TableCell
              onClick={() => openModal(row)}
              sx={{ whiteSpace: "nowrap" }}
            >
              {row.project.name}
            </TableCell>
            <TableCell
              onClick={() => openModal(row)}
              sx={{ whiteSpace: "nowrap" }}
            >
              {row.department.name}
            </TableCell>
            <TableCell
              onClick={() => openModal(row)}
              sx={{ whiteSpace: "nowrap" }}
            >
              {row.line.name}
            </TableCell>

            <TableCell
              onClick={() => openModal(row)}
              sx={{
                whiteSpace: "nowrap",
                bgcolor: "rgba(221, 234, 220, 1)",
                borderRadius: isNotRecruiter() ? "4px" : "4px 0 0 4px",
                boxSizing: "border-box",
              }}
            >
              {row.scheduleQuantity}
            </TableCell>
            {isNotRecruiter() && (
              <TableCell
                onClick={() => openModal(row)}
                sx={{ whiteSpace: "nowrap" }}
              >
                {row.needRecruiters}
              </TableCell>
            )}
            {isNotRecruiter() && (
              <TableCell
                onClick={() => openModal(row)}
                sx={{ whiteSpace: "nowrap" }}
              >
                {row.atInterviewStage}
              </TableCell>
            )}
            {isNotRecruiter() && (
              <TableCell
                onClick={() => openModal(row)}
                sx={{ whiteSpace: "nowrap" }}
              >
                {row.atRegistrationStage}
              </TableCell>
            )}
            {isNotRecruiter() && (
              <TableCell
                onClick={() => openModal(row)}
                sx={{
                  whiteSpace: "nowrap",
                  bgcolor: "rgba(221, 234, 220, 1)",
                  borderRadius: "4px",
                  boxSizing: "border-box",
                }}
              >
                {row.trainingStage}
              </TableCell>
            )}
            {isNotRecruiter() && (
              <TableCell
                onClick={() => openModal(row)}
                sx={{ whiteSpace: "nowrap" }}
              >
                {row.screeningAfterInterview}
              </TableCell>
            )}
            {isNotRecruiter() && (
              <TableCell
                onClick={() => openModal(row)}
                sx={{
                  whiteSpace: "nowrap",
                  bgcolor: "rgba(221, 234, 220, 1)",
                  borderRadius: "4px 0 0 4px",
                }}
              >
                {row.providesServices}
              </TableCell>
            )}
            <TableCell
              onClick={() => openModal(row)}
              sx={{
                whiteSpace: "nowrap",
                bgcolor: "rgba(221, 234, 220, 1)",
                borderRadius: "0 4px 4px 0",
              }}
            >
              {row.scheduleQuantityLeft}
            </TableCell>
            {isNotRecruiter() && (
              <TableCell
                onClick={() => openModal(row)}
                sx={{ whiteSpace: "nowrap" }}
              >
                {row.translateHiring}
              </TableCell>
            )}

            <IconButton
              onClick={() => {
                dispatch(setAvailableScheduleCandidates(row))
                setOpen({
                  ...open,
                  openCreateAvailableSchedule: { open: true, type: "info" },
                })
              }}
              sx={{
                backgroundColor: "rgba(232, 245, 231, 1)",
                opacity: 0,
                transition: "opacity 0.3s",
                position: "sticky",
                right: "0px",
                top: "10px",
                height: "52px",
                bgcolor: "rgba(232, 245, 231, 1)",
                borderRadius: "4px",
                minWidth: "54px",
                border: "1px solid #1B9C18",
                ":hover": {
                  backgroundColor: "rgba(232, 245, 231, 1)",
                  opacity: 1,
                },
              }}
              className="iconButton"
              size="small"
            >
              <RecentActorsIcon color="primary" sx={{ borderRadius: "4px" }} />
            </IconButton>
          </TableRow>
        )
      })}

      {/* {availableSchedule.data?.length === 0 && <NoRowsOverlay />} */}

      <></>
    </>
  )
}

export default AvailableScheduleRow
